import { invariant } from "@coinbot/forge-api/helpers";

import { getAxiosClient } from "../shared";
import { parseAction } from "./parseAction";
import { ForgeAction, MidgardActionsResponse } from "./types";

export const getActionsByAddress = async (
  address: string | undefined | null,
): Promise<ForgeAction[] | undefined> => {
  try {
    invariant(address && typeof address === "string", "address is required");

    const queryParams = new URLSearchParams();

    queryParams.append("address", address);
    queryParams.append("offset", "0");
    queryParams.append("limit", "10");

    // NOTE: midgard instance hosted on TS is not updating response, even when actions happened
    // const { data } = await midgard.get<MidgardActionsResponse>(`actions?${queryParams?.toString()}`);

    const { data } = await getAxiosClient({
      baseURL: "https://midgard.ninerealms.com/v2/",
    }).get<MidgardActionsResponse>(`actions?${queryParams?.toString()}`);

    const actions = data?.actions?.map(parseAction);

    return actions;
  } catch (err) {
    console.error("error getActionsByAddress", err);
    return;
  }
};
